<template>
  <v-dialog
    content-class="dialog-top"
    :value="value"
    max-width="480"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title
        style="background-color: #5cb860; color: white; justify-content: center;"
        class="headline py-2"
      >
        <v-icon color="white" left small>mdi-printer</v-icon>
        Print {{ isJewish ? "Yiddish" : "Gregorian" }} Calendar
      </v-card-title>
      <v-card-text class="pt-4 pb-2 px-4">
        <v-radio-group v-model="printMode" hide-details class="mt-0">
          <v-radio
            color="success"
            label="Single Month"
            value="single"
          ></v-radio>
          <v-radio
            color="success"
            label="Month Range"
            value="range"
          ></v-radio>
        </v-radio-group>

        <template v-if="isJewish">
          <div v-if="printMode === 'single'" class="mt-3">
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-select
                  v-model="singleMonth"
                  :items="hebrewMonthItemsFor(singleYear)"
                  item-text="text"
                  item-value="value"
                  label="חודש"
                  style="direction: rtl;"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-layout row no-wrap>
                  <v-flex xs6 class="pr-1">
                    <v-text-field
                      v-model.number="singleYear"
                      label="שנת"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="pl-1">
                    <v-select
                      v-model="singleYear"
                      :items="hebrewYears"
                      item-text="text"
                      item-value="value"
                      style="direction: rtl;"
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div v-else class="mt-3">
            <div class="subheading mb-2">From</div>
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-select
                  v-model="fromMonth"
                  :items="hebrewMonthItemsFor(fromYear)"
                  item-text="text"
                  item-value="value"
                  label="חודש"
                  style="direction: rtl;"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-layout row no-wrap>
                  <v-flex xs6 class="pr-1">
                    <v-text-field
                      v-model.number="fromYear"
                      label="שנת"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="pl-1">
                    <v-select
                      v-model="fromYear"
                      :items="hebrewYears"
                      item-text="text"
                      item-value="value"
                      style="direction: rtl;"
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <div class="subheading mb-2 mt-4">To</div>
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-select
                  v-model="toMonth"
                  :items="hebrewMonthItemsFor(toYear)"
                  item-text="text"
                  item-value="value"
                  label="חודש"
                  style="direction: rtl;"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-layout row no-wrap>
                  <v-flex xs6 class="pr-1">
                    <v-text-field
                      v-model.number="toYear"
                      label="שנת"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="pl-1">
                    <v-select
                      v-model="toYear"
                      :items="hebrewYears"
                      item-text="text"
                      item-value="value"
                      style="direction: rtl;"
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </template>

        <template v-else>
          <div v-if="printMode === 'single'" class="mt-3">
            <v-layout row wrap>
              <v-flex xs7 class="pr-2">
                <v-select
                  v-model="singleMonth"
                  :items="gregorianMonths"
                  label="Month"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs5 class="pl-2">
                <v-text-field
                  v-model.number="singleYear"
                  label="Year"
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-else class="mt-3">
            <div class="subheading mb-2">From</div>
            <v-layout row wrap>
              <v-flex xs7 class="pr-2">
                <v-select
                  v-model="fromMonth"
                  :items="gregorianMonths"
                  label="Month"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs5 class="pl-2">
                <v-text-field
                  v-model.number="fromYear"
                  label="Year"
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="subheading mb-2 mt-4">To</div>
            <v-layout row wrap>
              <v-flex xs7 class="pr-2">
                <v-select
                  v-model="toMonth"
                  :items="gregorianMonths"
                  label="Month"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs5 class="pl-2">
                <v-text-field
                  v-model.number="toYear"
                  label="Year"
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="default" @click="$emit('input', false)"
          >Cancel</v-btn
        >
        <v-btn
          small
          color="success"
          :disabled="!canPrint"
          :loading="loading"
          @click="emitPrint"
        >
          <v-icon left small>mdi-printer</v-icon>
          Print
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { HDate, gematriya } from "@hebcal/core";

const GREGORIAN_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function toIsoDate(date) {
  return moment(date).format("YYYY-MM-DD");
}

function formatHebrewMonthName(gregorianDate) {
  return new Intl.DateTimeFormat("he-u-ca-hebrew", {
    month: "long",
  }).format(gregorianDate);
}

function hebrewMonthBounds(month, year) {
  const firstDay = new HDate(1, month, year);
  const lastDay = new HDate(firstDay.daysInMonth(), month, year);
  return {
    startDate: toIsoDate(firstDay.greg()),
    endDate: toIsoDate(lastDay.greg()),
  };
}

function gregorianMonthBounds(monthName, year) {
  const start = moment(`${monthName} ${year}`, "MMMM YYYY").startOf("month");
  const end = start.clone().endOf("month");
  return {
    startDate: start.format("YYYY-MM-DD"),
    endDate: end.format("YYYY-MM-DD"),
  };
}

function isValidHebrewYear(year) {
  return Number.isFinite(year) && year >= 5000 && year <= 5999;
}

function isValidGregorianYear(year) {
  return Number.isFinite(year) && year >= 1240 && year <= 2239;
}

export default {
  name: "CalendarPrintDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: String,
      default: "jewish",
    },
    defaultHebrewMonth: {
      type: Number,
      default: null,
    },
    defaultHebrewYear: {
      type: Number,
      default: null,
    },
    defaultGregorianMonth: {
      type: String,
      default: "",
    },
    defaultGregorianYear: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printMode: "single",
      singleMonth: null,
      singleYear: null,
      fromMonth: null,
      fromYear: null,
      toMonth: null,
      toYear: null,
      gregorianMonths: GREGORIAN_MONTHS,
    };
  },
  computed: {
    isJewish() {
      return this.viewMode === "jewish";
    },
    hebrewYears() {
      return Array.from({ length: 101 }, (_, index) => {
        const year = 5770 + index;
        return {
          text: gematriya(year, 3),
          value: year,
        };
      });
    },
    canPrint() {
      if (this.printMode === "single") {
        if (this.singleMonth == null || this.singleYear == null) return false;
        return this.isJewish
          ? isValidHebrewYear(Number(this.singleYear))
          : isValidGregorianYear(Number(this.singleYear));
      }

      if (
        this.fromMonth == null ||
        this.toMonth == null ||
        this.fromYear == null ||
        this.toYear == null
      ) {
        return false;
      }

      if (this.isJewish) {
        if (
          !isValidHebrewYear(Number(this.fromYear)) ||
          !isValidHebrewYear(Number(this.toYear))
        ) {
          return false;
        }
        try {
          const fromAbs = new HDate(
            1,
            Number(this.fromMonth),
            Number(this.fromYear)
          ).abs();
          const toAbs = new HDate(
            1,
            Number(this.toMonth),
            Number(this.toYear)
          ).abs();
          return fromAbs <= toAbs;
        } catch (e) {
          return false;
        }
      }

      if (
        !isValidGregorianYear(Number(this.fromYear)) ||
        !isValidGregorianYear(Number(this.toYear))
      ) {
        return false;
      }
      const from = moment(
        `${this.fromMonth} ${this.fromYear}`,
        "MMMM YYYY"
      );
      const to = moment(`${this.toMonth} ${this.toYear}`, "MMMM YYYY");
      return from.isValid() && to.isValid() && from.isSameOrBefore(to, "month");
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.resetDefaults();
      }
    },
    singleYear(year) {
      if (!this.isJewish) return;
      this.singleMonth = this.clampHebrewMonth(this.singleMonth, year);
    },
    fromYear(year) {
      if (!this.isJewish) return;
      this.fromMonth = this.clampHebrewMonth(this.fromMonth, year);
    },
    toYear(year) {
      if (!this.isJewish) return;
      this.toMonth = this.clampHebrewMonth(this.toMonth, year);
    },
  },
  methods: {
    hebrewMonthItemsFor(year) {
      if (!isValidHebrewYear(Number(year))) return [];
      const monthsInYear = HDate.monthsInYear(Number(year));
      return Array.from({ length: monthsInYear }, (_, index) => {
        const month = index + 1;
        const hd = new HDate(1, month, Number(year));
        return {
          text: formatHebrewMonthName(hd.greg()),
          value: month,
        };
      });
    },
    clampHebrewMonth(month, year) {
      if (!isValidHebrewYear(Number(year))) return month;
      const maxMonth = HDate.monthsInYear(Number(year));
      if (month == null) return 1;
      if (month > maxMonth) return maxMonth;
      if (month < 1) return 1;
      return month;
    },
    resetDefaults() {
      this.printMode = "single";
      if (this.isJewish) {
        const year = Number(this.defaultHebrewYear) || new HDate(new Date()).getFullYear();
        const month = this.clampHebrewMonth(
          Number(this.defaultHebrewMonth) || new HDate(new Date()).getMonth(),
          year
        );
        this.singleMonth = month;
        this.singleYear = year;
        this.fromMonth = month;
        this.fromYear = year;
        this.toMonth = month;
        this.toYear = year;
      } else {
        const month =
          this.defaultGregorianMonth ||
          GREGORIAN_MONTHS[moment().month()];
        const year = Number(this.defaultGregorianYear) || moment().year();
        this.singleMonth = month;
        this.singleYear = year;
        this.fromMonth = month;
        this.fromYear = year;
        this.toMonth = month;
        this.toYear = year;
      }
    },
    resolveDateRange() {
      if (this.isJewish) {
        if (this.printMode === "single") {
          return hebrewMonthBounds(
            Number(this.singleMonth),
            Number(this.singleYear)
          );
        }
        const from = hebrewMonthBounds(
          Number(this.fromMonth),
          Number(this.fromYear)
        );
        const to = hebrewMonthBounds(
          Number(this.toMonth),
          Number(this.toYear)
        );
        return {
          startDate: from.startDate,
          endDate: to.endDate,
        };
      }

      if (this.printMode === "single") {
        return gregorianMonthBounds(
          this.singleMonth,
          Number(this.singleYear)
        );
      }
      const from = gregorianMonthBounds(
        this.fromMonth,
        Number(this.fromYear)
      );
      const to = gregorianMonthBounds(this.toMonth, Number(this.toYear));
      return {
        startDate: from.startDate,
        endDate: to.endDate,
      };
    },
    emitPrint() {
      if (!this.canPrint) return;
      const { startDate, endDate } = this.resolveDateRange();
      this.$emit("print", { startDate, endDate });
    },
  },
};
</script>
<style>
.dialog-top {
  align-self: flex-start;
  margin-top: 80px;
}
</style>
